import React from 'react';
import src from './source';
import * as FieldUtil from './fieldUtil';
import * as DetailUtil from './detailUtil';
import * as _ from './common';
import { formatDate } from './formatUtil'

//修改密级，统一入口，同时修改secLevelInfo和mainData
export const changeSecLevelInfo = (level, validity) => {
    const { globalStore } = src;
    const { setSecLevelInfo } = globalStore;
    setSecLevelInfo({ secLevel: level });
    const fieldObj = FieldUtil.getFieldObj("field-10", "main");
    if (fieldObj)
        fieldObj.changeValueObj({ value: level });
    if (typeof validity !== "undefined")
        setSecLevelInfo({ secValidity: validity });     //传参数才修改密级期限
}

//表单加载时处理密级信息
export const loadManagerSecLevelInfo = () =>{
    let { commonParam, secLevelInfo={}, controlVariableMap } = src.globalStore;
    const {isOpenSec}=secLevelInfo;
    const { cellInfo, tableInfo } = src.layoutStore;
    if(!isOpenSec) return;
    let viewAttr = tableInfo.main.fieldinfomap["-10"].viewattr;
    if(commonParam.iscreate == "1" && _.has(cellInfo, ["fieldCellInfo", "-10"]) && viewAttr > 1){
        //密级字段放入模版情况，创建默认为空
        changeSecLevelInfo("", "");
    }else{
        const {secLevel,secValidity}=secLevelInfo;
        secLevelInfo.secValidityMap[secLevel]=secValidity;
        //有默认值的，同步到maindata，避免升级后代码块从maindata获取不到
        const fieldObj = FieldUtil.getFieldObj("field-10", "main");
        if(fieldObj)
            fieldObj.changeValueObj({ value: secLevelInfo.secLevel });
        if(secLevel !== ""){
            controlVariableMap("miniWfSecLevel", secLevel)
        }
    }
}

//获取当前密级值，统一从secLevelInfo获取
export const getSecLevel = () =>{
    return src.globalStore.secLevelInfo && src.globalStore.secLevelInfo.secLevel || "";
}

//获取当前密级对象，统一从secLevelInfo获取
export const getSecLevelInfo = () =>{
    return src.globalStore.secLevelInfo && src.globalStore.secLevelInfo || {};
}

//获取密级和密级期限
export const getSecAndValidity = () => {
    const {secLevelInfo={}} = src.globalStore;
    const {secLevel, secValidity} = secLevelInfo;
    if(!secLevel){
        return "";
    }else if(secLevel > 2){
        return secLevel;
    }else if(secLevel <= 2){
        return secLevel+"#"+secValidity;
    }
}

//根据输入的密级，限制密级字段中下拉选项
export const controlSecFieldOptions = () =>{
    const{ secLevelInfo = {}, setSecLevelInfo } = src.globalStore;
    const { secLevel } = secLevelInfo;
    if(secLevel == "") return;
    if(secLevelInfo.secLevelOption){
        let newSecLevelInfo = secLevelInfo.secLevelOption.filter(item=>{
            return item.key <= secLevel;
        })
        setSecLevelInfo({secLevelOption:newSecLevelInfo});
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/util/public/secLevelUtil.js